import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import '../../../css/TerminalHandling/TPTRequestService.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import unchecked from '../../../Assets/TruckVisits/Assets/unchecked-box.svg';
import checked from '../../../Assets/NominateRequest/selectedCheckBox.svg';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { TERMINAL_HANDLING_ENDPOINT, ALLPORTTERMINALS_ENDPOIN } from '../../../Services/config/apiEndPoints';
import TerminalSuccessModal from '../../Shared/TerminalSuccessModal';
import { PortAlphaSorting } from '../../../Services/utils/AlphaSorting';


class CreateTPTRequest extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            NameofCompany: '',
            ContactPerson: '',
            EmailAddress: '',
            TelephoneNo: '',
            FaxNo: '',
            TPTAccountNo: '',
            Terminal: '',
            Terminaldropdown: false,
            Terminaldata: [],
            CargoPackaging: '',
            CargoPackagingdropdown: false,
            CargoPackagingdata: [],
            Commodity: '',
            Statement: '',
            EnvironmentalHealthRisks: '',
            Length: '',
            Width: '',
            Height: '',
            TonnageperItem: '',
            TotalTonnage: '',
            DateApplicationSubmitted: new Date(),
            DateServiceRequired: '',
            DateServiceRequiredValidate: false,
            DateServiceRequiredValue: new Date(),
            DateServiceRequiredCalendar: false,
            Shipping: true,
            Landing: false,
            Other: false,
            Risks: true,
            Vehicles: 'Tracks',
            SetVehicles: '',
            Comment: '',
            CommenttextLimit: 0,
            hasOpenSuccess: false,
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    CargoPackagingdata = [{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" },
    { name: "Loose Bags" }, { name: "Loose Steel/Timber" }, { name: "Vehicles" }]

    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        this.getAllVessel();
    }
    onSubmitRequest = () => {
        if (this.handleValidation()) {
            ApiCall(
                'POST',
                serviceBaseURL + TERMINAL_HANDLING_ENDPOINT,
                {
                    "requestId": 0,
                    "responseData": {
                        "accountNbr": this.state.TPTAccountNo,
                        "breadth": this.state.Width,
                        "cargoPacking": this.state.CargoPackaging,
                        "comments": this.state.Comment,
                        "commodity": this.state.Commodity,
                        "commodityStatement": this.state.Statement,
                        "companyName": this.state.NameofCompany,
                        "contactPerson": this.state.ContactPerson,
                        "dateTime": 0,
                        "email": this.state.EmailAddress,
                        "fax": this.state.FaxNo,
                        "height": this.state.Height,

                        "length": this.state.Length,

                        "risk": this.state.Risks,
                        "riskStatement": this.state.EnvironmentalHealthRisks,
                        "serviceDates": this.state.DateServiceRequiredValue.getTime(),
                        'serviceType': this.state.Shipping ? 'Shipping' : (this.state.Landing ? 'Landing' : (this.state.Other ? 'Other' : '')),


                        "status": "Mail Sent",
                        "submitDate": this.state.DateApplicationSubmitted.getTime(),
                        "telephone": this.state.TelephoneNo,
                        "terminal": this.state.Terminal,
                        "tonnagePerItem": this.state.TonnageperItem,
                        "totalTonnage": this.state.TotalTonnage,
                        "vehicleType": this.state.Vehicles
                    }
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({ hasOpenSuccess: true });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    getAllVessel = () => {
        ApiCall(
            'GET',
            utilityBaseURL + ALLPORTTERMINALS_ENDPOIN,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    data = PortAlphaSorting(data);
                    this.setState({ Terminaldata: data });
                }
            } else {
                console.log('Something went wrong!');
            }
        });
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push("/TPTRequestHistory");
    };
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ Terminaldropdown: false });
            this.setState({ CargoPackagingdropdown: false });
            this.setState({ DateServiceRequiredCalendar: false });
        }
    };
    handleChangeNameofCompany = (e) => {
        this.setState({ NameofCompany: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                NameofCompany: ''
            }
        });
        document.getElementsByName('NameofCompany')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeContactPerson = (e) => {
        this.setState({ ContactPerson: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                ContactPerson: ''
            }
        });
        document.getElementsByName('ContactPerson')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeEmailAddress = (e) => {
        this.setState({ EmailAddress: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                EmailAddress: ''
            }
        });
        document.getElementsByName('EmailAddress')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTelephoneNo = (e) => {
        this.setState({ TelephoneNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                TelephoneNo: ''
            }
        });
        document.getElementsByName('TelephoneNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeFaxNo = (e) => {
        this.setState({ FaxNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                FaxNo: ''
            }
        });
        document.getElementsByName('FaxNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTPTAccountNo = (e) => {
        this.setState({ TPTAccountNo: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                TPTAccountNo: ''
            }
        });
        document.getElementsByName('TPTAccountNo')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeCommodity = (e) => {
        this.setState({ Commodity: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                Commodity: ''
            }
        });
        document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeStatement = (e) => {
        this.setState({ Statement: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                Statement: ''
            }
        });
        document.getElementsByName('Statement')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeEnvironmentalHealthRisks = (e) => {
        this.setState({ EnvironmentalHealthRisks: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                EnvironmentalHealthRisks: ''
            }
        });
        document.getElementsByName('EnvironmentalHealthRisks')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeLength = (e) => {
        this.setState({ Length: e.target.value });
        if (this.state.Length?.length > 0 && this.state.Width?.length > 0 && this.state.Height?.length > 0) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    Dimensions: ''
                }
            });
        }
        document.getElementsByName('Length')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeWidth = (e) => {
        this.setState({ Width: e.target.value });
        if (this.state.Length.length > 0 && this.state.Width.length > 0 && this.state.Height.length > 0) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    Dimensions: ''
                }
            });
        }
        document.getElementsByName('Width')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeHeight = (e) => {
        this.setState({ Height: e.target.value });
        if (this.state.Length?.length > 0 && this.state.Width?.length > 0 && this.state.Height?.length > 0) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    Dimensions: ''
                }
            });
        }
        document.getElementsByName('Height')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTonnageperItem = (e) => {
        this.setState({ TonnageperItem: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                TonnageperItem: ''
            }
        });
        document.getElementsByName('TonnageperItem')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTotalTonnage = (e) => {
        this.setState({ TotalTonnage: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                TotalTonnage: ''
            }
        });
        document.getElementsByName('TotalTonnage')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeComment = (e) => {
        if (e.target.value?.length <= 180) {
            this.setState({ CommenttextLimit: e.target.value?.length });
            this.setState({ Comment: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    Comment: ''
                }
            });
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    handleChangeDateServiceRequired = (e) => {
        this.setState({ DateServiceRequired: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                DateServiceRequired: ''
            }
        });
        document.getElementsByName('DateServiceRequired')[0].style.borderColor = ColorCode.colorCode.black;
    }
    getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    handleDatePassDOBChanged = (e) => {
        this.setState({
            DateServiceRequired: this.getDateFormated(e),
            DateServiceRequiredValue: e
        });
        this.setState({
            errors: {
                ...this.state.errors,
                DateServiceRequired: ''
            }
        });
        document.getElementsByName('DateServiceRequired')[0].style.borderColor = ColorCode.colorCode.black;
    }
    togglePassDOBCalendar = () => {
        this.setState({
            DateServiceRequiredCalendar: !this.state.DateServiceRequiredCalendar,
            DateServiceRequiredValidate: true
        });
    }
    toggleServiceCheckBox = (e) => {
        if (e === "Shipping") {
            this.setState({ Shipping: true });
            this.setState({ Landing: false });
            this.setState({ Other: false });
        } else if (e === "Landing") {
            this.setState({ Landing: true });
            this.setState({ Shipping: false });
            this.setState({ Other: false });
        } else if (e === "Other") {
            this.setState({ Other: true });
            this.setState({ Shipping: false });
            this.setState({ Landing: false });;
        }
        this.setState({
            errors: {
                ...this.state.errors,
                service: ''
            }
        });
    }
    toggleRisksCheckBox = () => {
        this.setState({ Risks: !this.state.Risks }, () => {
            if (!this.state.Risks) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        EnvironmentalHealthRisks: ''
                    }
                });
                document.getElementsByName('EnvironmentalHealthRisks')[0].style.borderColor = ColorCode.colorCode.black;
            }
        })
    }
    toggleVehiclesCheckBox = (e) => {
        if (e === "Tracks") {
            this.setState({ Vehicles: "Tracks" })
        } else if (e === "Wheels") {
            this.setState({ Vehicles: "Wheels" })
        }

    }
    toggleDropdownTerminal = () => {
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
    };
    changeRoleTypeTerminal = (index) => {
        const found = this.state.Terminaldata?.find((name) => {
            if (name.portId === this.state.Terminaldata[index].portId) {
                return name
            }
        })
        this.setState({ Terminal: found.portName });
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                Terminal: ''
            }
        });
        document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
    }
    toggleDropdownCargoPackaging = () => {
        this.setState({ CargoPackagingdropdown: !this.state.CargoPackagingdropdown });
    };
    changeRoleTypeCargoPackaging = (event) => {
        const found = this.CargoPackagingdata?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ CargoPackaging: found.name });
        this.setState({ CargoPackagingdropdown: !this.state.CargoPackagingdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                CargoPackaging: ''
            }
        });
        document.getElementsByName('CargoPackaging')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternEmail = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        if (!this.state.NameofCompany) {
            formIsValid = false;
            errors["NameofCompany"] = Message.validation.required;
            document.getElementsByName('NameofCompany')[0].style.borderColor = ColorCode.colorCode.red;
        } else if (!patternCharacter.test(this.state.NameofCompany)) {
            formIsValid = false;
            errors["NameofCompany"] = Message.validation.alpha;
            document.getElementsByName('NameofCompany')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('NameofCompany')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.ContactPerson) {
            formIsValid = false;
            errors["ContactPerson"] = Message.validation.required;
            document.getElementsByName('ContactPerson')[0].style.borderColor = ColorCode.colorCode.red;
        } else if (!patternCharacter.test(this.state.ContactPerson)) {
            formIsValid = false;
            errors["ContactPerson"] = Message.validation.alpha;
            document.getElementsByName('ContactPerson')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('ContactPerson')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.EmailAddress) {
            formIsValid = false;
            errors["EmailAddress"] = Message.validation.required;
            document.getElementsByName('EmailAddress')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternEmail.test(this.state.EmailAddress)) {
            formIsValid = false;
            errors["EmailAddress"] = Message.validation.email;
            document.getElementsByName('EmailAddress')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('EmailAddress')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.TelephoneNo) {
            formIsValid = false;
            errors["TelephoneNo"] = Message.validation.required;
            document.getElementsByName('TelephoneNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.TelephoneNo)) {
            formIsValid = false;
            errors["TelephoneNo"] = Message.validation.num;
            document.getElementsByName('TelephoneNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('TelephoneNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.FaxNo) {
            formIsValid = false;
            errors["FaxNo"] = Message.validation.required;
            document.getElementsByName('FaxNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.FaxNo)) {
            formIsValid = false;
            errors["FaxNo"] = Message.validation.num;
            document.getElementsByName('FaxNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('FaxNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.TPTAccountNo) {
            formIsValid = false;
            errors["TPTAccountNo"] = Message.validation.required;
            document.getElementsByName('TPTAccountNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.TPTAccountNo)) {
            formIsValid = false;
            errors["TPTAccountNo"] = Message.validation.num;
            document.getElementsByName('TPTAccountNo')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('TPTAccountNo')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Commodity) {
            formIsValid = false;
            errors["Commodity"] = Message.validation.required;
            document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Commodity')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Statement) {
            formIsValid = false;
            errors["Statement"] = Message.validation.required;
            document.getElementsByName('Statement')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Statement')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.EnvironmentalHealthRisks && this.state.Risks) {
            formIsValid = false;
            errors["EnvironmentalHealthRisks"] = Message.validation.required;
            document.getElementsByName('EnvironmentalHealthRisks')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('EnvironmentalHealthRisks')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Length) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.required;
            document.getElementsByName('Length')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.Length)) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.num;
            document.getElementsByName('Length')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('Length')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Width) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.required;
            document.getElementsByName('Width')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.Width)) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.num;
            document.getElementsByName('Width')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('Width')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Height) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.required;
            document.getElementsByName('Height')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.Height)) {
            formIsValid = false;
            errors["Dimensions"] = Message.validation.num;
            document.getElementsByName('Height')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('Height')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.TonnageperItem) {
            formIsValid = false;
            errors["TonnageperItem"] = Message.validation.required;
            document.getElementsByName('TonnageperItem')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.TonnageperItem)) {
            formIsValid = false;
            errors["TonnageperItem"] = Message.validation.num;
            document.getElementsByName('TonnageperItem')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('TonnageperItem')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.TotalTonnage) {
            formIsValid = false;
            errors["TotalTonnage"] = Message.validation.required;
            document.getElementsByName('TotalTonnage')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else if (!patternDigit.test(this.state.TotalTonnage)) {
            formIsValid = false;
            errors["TotalTonnage"] = Message.validation.num;
            document.getElementsByName('TotalTonnage')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('TotalTonnage')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Comment) {
            formIsValid = false;
            errors["Comment"] = Message.validation.required;
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Comment')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Terminal) {
            formIsValid = false;
            errors["Terminal"] = Message.validation.required;
            document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.CargoPackaging) {
            formIsValid = false;
            errors["CargoPackaging"] = Message.validation.required;
            document.getElementsByName('CargoPackaging')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('CargoPackaging')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.Shipping && !this.state.Landing && !this.state.Other) {
            formIsValid = false;
            errors["service"] = Message.validation.required;
        }
        if (!this.state.DateServiceRequired) {
            formIsValid = false;
            errors["DateServiceRequired"] = Message.validation.required;
            document.getElementsByName('DateServiceRequired')[0].style.borderColor = ColorCode.colorCode.red;
        }
        else {
            document.getElementsByName('DateServiceRequired')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    render() {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let DasFormatted_date = this.state.DateApplicationSubmitted.getDate() + "-" + months[this.state.DateApplicationSubmitted.getMonth()] + "-" + this.state.DateApplicationSubmitted.getFullYear();
        if (this.state.DateApplicationSubmitted.getDate() <= 9) {
            DasFormatted_date = "0" + this.state.DateApplicationSubmitted.getDate() + "-" + months[this.state.DateApplicationSubmitted.getMonth()] + "-" + this.state.DateApplicationSubmitted.getFullYear();
        }
        return (
            <div class="CrtTptReqestOutercolor">
                <MetaDecorator title={TitleDescription.TPTRequestServiceTitle} description={TitleDescription.TPTRequestServiceDiscription} />
                <Header tilesFetched={() => { }} />
                <div class="CrtTptReqestOuterDivcss">
                    <div id="CrtTptReqestBoxDiv">
                        <nav class="CrtTptReqestNavbar">
                            <div className="CrtTptReqestNavbarName">
                                <small id="CrtTptReqestNavbarText">Request Service</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="CrtTptReqestMidPartition">
                            <div class="CrtTptReqestCrdHeading">Customer Details</div>
                            <div class="CrtTptReqestCardcss">
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Name of Company</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="NameofCompany"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Name of Company"
                                            type="text" value={this.state.NameofCompany}
                                            onChange={this.handleChangeNameofCompany}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["NameofCompany"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Contact Person</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="ContactPerson"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Contact Person"
                                            type="text" value={this.state.ContactPerson}
                                            onChange={this.handleChangeContactPerson}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["ContactPerson"]}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="CrtTptReqestCrdHeading">Contact Details</div>
                            <div class="CrtTptReqestCardcss">
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Email Address</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="EmailAddress"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Email Address"
                                            type="text" value={this.state.EmailAddress}
                                            onChange={this.handleChangeEmailAddress}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["EmailAddress"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Telephone No.</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="TelephoneNo"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Telephone No."
                                            type="text" value={this.state.TelephoneNo}
                                            onChange={this.handleChangeTelephoneNo}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["TelephoneNo"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Fax No.</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="FaxNo"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Fax No."
                                            type="text" value={this.state.FaxNo}
                                            onChange={this.handleChangeFaxNo}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["FaxNo"]}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="CrtTptReqestCrdHeading">Transport Terminal Details</div>
                            <div class="CrtTptReqestCardcss">
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Transnet Port Terminal Account No.</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="TPTAccountNo"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Transnet Port Terminal Account No."
                                            type="text" value={this.state.TPTAccountNo}
                                            onChange={this.handleChangeTPTAccountNo}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["TPTAccountNo"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Select Terminal</small>
                                    <div id="CrtTptReqestInpHeadBtm">(Select at which terminal at service to be provided)</div>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" > 
                                        <Input
                                            readOnly name="Terminal" class="input CrtTptReqestInpDropCss" placeholder="Select Terminal"
                                            type="text" value={this.state.Terminal}
                                        />
                                        <div className="CrtTptReqestDropError">{this.state.errors["Terminal"]}</div>
                                        <i id="CrtTptReqestInp_imgDrop" onClick={this.toggleDropdownTerminal}>
                                            {this.state.Terminaldropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.Terminaldropdown && (
                                        <div class="CrtTptReqestDropDowmDiv" >
                                            <div class="CrtTptReqestDropCard" ref={this.container} >
                                                {(this.state.Terminaldata?.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={() => this.changeRoleTypeTerminal(index)} id="CrtTptReqestDropRowSize">
                                                            <small class="" id="CrtTptReqestDropRowText" >{name?.portName} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Select Type of Service Required</small>
                                    <div class="CrtTptReqestServiceTypeDiv">
                                        <div id="CrtTptReqestSvcCheckdivid1" class="CrtTptReqestSvcCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Shipping ? selectedRadioButton : defautRadioButton}
                                                onClick={() => this.toggleServiceCheckBox("Shipping")}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Shipping</div>
                                        </div>
                                        <div id="CrtTptReqestSvcCheckdivid2" class="CrtTptReqestSvcCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Landing ? selectedRadioButton : defautRadioButton}
                                                onClick={() => this.toggleServiceCheckBox("Landing")}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Landing</div>
                                        </div>
                                        <div id="CrtTptReqestSvcCheckdivid3" class="CrtTptReqestSvcCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Other ? selectedRadioButton : defautRadioButton}
                                                onClick={() => this.toggleServiceCheckBox("Other")}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Other</div>
                                        </div>
                                    </div>
                                    <div className="CrtTptReqestError">{this.state.errors["service"]}</div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Commodity</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="Commodity"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Commodity"
                                            type="text" value={this.state.Commodity}
                                            onChange={this.handleChangeCommodity}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["Commodity"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">State If You Require Fines or Storage</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="Statement"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Statement"
                                            type="text" value={this.state.Statement}
                                            onChange={this.handleChangeStatement}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["Statement"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <div id="CrtTptReqestRiskInpHeading">Does/Can The Commodity Pose Any Environmental/Health Risks</div>
                                    <div class="CrtTptReqestServiceTypeDiv">
                                        <div class="CrtTptReqestRisksCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Risks ? checked : unchecked}
                                                onClick={this.toggleRisksCheckBox}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Yes</div>
                                        </div>
                                        <div class="CrtTptReqestRisksCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={!this.state.Risks ? checked : unchecked}
                                                onClick={this.toggleRisksCheckBox}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">No</div>
                                        </div>
                                    </div>
                                    <div class="CrtTptReqestRisksBlowText">If “Yes” please describe precautions to be taken and provide the relevant Material Data Safety Sheet (MSDS)</div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Environmental / Health Risks</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="EnvironmentalHealthRisks"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Environmental / Health Risks"
                                            type="text" value={this.state.EnvironmentalHealthRisks}
                                            onChange={this.handleChangeEnvironmentalHealthRisks}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["EnvironmentalHealthRisks"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Enter Dimensions</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDimensionDiv" >
                                        <div class="CrtTptReqestDimensionSmDiv">
                                            <Input
                                                name="Length"
                                                class="input CrtTptReqestDimensionInp CrtTptReqestInpCss" placeholder="Length"
                                                type="text" value={this.state.Length}
                                                onChange={this.handleChangeLength}
                                            />

                                        </div>
                                        <small class="CrtTptReqestmmtext">mm</small>
                                        <div class="CrtTptReqestDimensionSmDiv">
                                            <Input
                                                name="Width"
                                                class="input CrtTptReqestDimensionInp CrtTptReqestInpCss" placeholder="Width"
                                                type="text" value={this.state.Width}
                                                onChange={this.handleChangeWidth}
                                            />
                                        </div>
                                        <small class="CrtTptReqestmmtext">mm</small>
                                        <div class="CrtTptReqestDimensionSmDiv">
                                            <Input
                                                name="Height"
                                                class="input CrtTptReqestDimensionInp CrtTptReqestInpCss" placeholder="Height"
                                                type="text" value={this.state.Height}
                                                onChange={this.handleChangeHeight}
                                            />
                                        </div>
                                        <small class="CrtTptReqestmmtext">mm</small>
                                    </div>
                                    <div className="CrtTptReqestError">{this.state.errors["Dimensions"]}</div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Select Cargo Packaging</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            readOnly name="CargoPackaging" class="input CrtTptReqestInpDropCss" placeholder="Select Cargo Packaging"
                                            type="text" value={this.state.CargoPackaging}
                                        />
                                        <div className="CrtTptReqestDropError">{this.state.errors["CargoPackaging"]}</div>
                                        <i id="CrtTptReqestInp_imgDrop" onClick={this.toggleDropdownCargoPackaging}>
                                            {this.state.CargoPackagingdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.CargoPackagingdropdown && (
                                        <div class="CrtTptReqestDropDowmDiv" >
                                            <div class="CrtTptReqestDropCard" ref={this.container} >
                                                {(this.CargoPackagingdata?.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypeCargoPackaging(val)} id="CrtTptReqestDropRowSize">
                                                            <small class="" id="CrtTptReqestDropRowText" >{name?.name} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">If Vehicles on Tracks or Wheels Please Select</small>
                                    <div class="CrtTptReqestServiceTypeDiv">
                                        <div class="CrtTptReqestSvcCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Vehicles === "Tracks" ? selectedRadioButton : defautRadioButton}
                                                onClick={() => this.toggleVehiclesCheckBox("Tracks")}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Tracks</div>
                                        </div>
                                        <div class="CrtTptReqestSvcCheckdiv">
                                            <img id="CrtTptReqestSvcCheck_img"
                                                src={this.state.Vehicles === "Wheels" ? selectedRadioButton : defautRadioButton}
                                                onClick={() => this.toggleVehiclesCheckBox("Wheels")}
                                            />
                                            <div class="CrtTptReqestSvcChecktext">Wheels</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Tonnage per Item</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="TonnageperItem"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Tonnage per Item"
                                            type="text" value={this.state.TonnageperItem}
                                            onChange={this.handleChangeTonnageperItem}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["TonnageperItem"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Total Tonnage</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="TotalTonnage"
                                            class="input CrtTptReqestInpCss" placeholder="Enter Total Tonnage"
                                            type="text" value={this.state.TotalTonnage}
                                            onChange={this.handleChangeTotalTonnage}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["TotalTonnage"]}</div>
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Date Application Submitted</small>
                                    <div class="CrtTptReqestDateAppSub">{DasFormatted_date}</div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Date Service Required</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv">
                                        <input
                                            readOnly
                                            class="inpuut1 CrtTptReqestInpCss"
                                            placeholder="Select Date"
                                            type="text"
                                            name="DateServiceRequired"
                                            autoComplete="off"
                                            value={this.state.DateServiceRequired}
                                            onChange={this.handleChangeDateServiceRequired} />
                                        <div className="CrtTptReqestDropError">{this.state.errors["DateServiceRequired"]}</div>
                                        <div class="idcalenderwidth">
                                            {this.state.DateServiceRequiredCalendar ?
                                                <div ref={this.container}>
                                                    <Calendar onChange={this.handleDatePassDOBChanged} value={this.state.DateServiceRequiredValue}
                                                        minDate={new Date()} />
                                                </div> : null}
                                        </div>
                                        <img id="CrtTptReqestInp_imgCal" src={calender} alt="" onClick={this.togglePassDOBCalendar}
                                        />
                                    </div>
                                </div>
                                <div class="CrtTptReqestInpSize">
                                    <small id="CrtTptReqestInpHeading">Comment</small>
                                    <div className="pass-wrapper" id="CrtTptReqestInpDiv" >
                                        <Input
                                            name="Comment"
                                            class="input CrtTptReqestInpCss" placeholder="Enter your comment"
                                            type="text" value={this.state.Comment}
                                            onChange={this.handleChangeComment}
                                        />
                                        <div className="CrtTptReqestError">{this.state.errors["Comment"]}</div>
                                        <small class="inpsmallraise">{this.state.CommenttextLimit}/180</small>
                                    </div>
                                </div>
                            </div>
                            <div class="CrtTptReqestBtmNoticeTextA">1. Kindly ensure that all information is completed on this screen as the information is required to calculate tariffs. </div>
                            <div class="CrtTptReqestBtmNoticeTextB">2. Please be advised that a time frame of 24 hours is allocated within which to respond to this request.</div>
                            <div class="CrtTptReqestBtnDiv">
                                <Button class="CrtTptReqestBtnCss" onClick={this.onSubmitRequest}>
                                    <small class="CrtTptReqestBtntext">Submit Request</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="CrtTptReqestFooterUnfixed">
                    <Footer />
                </div>
                <div class="CrtTptReqestFooterFixed">
                    <Footer2 />
                </div>
                <TerminalSuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="TerminalSuccessDivOut">
                            <div class="TerminalSuccessSmupdiv">
                                <small class="TerminalSuccessSmupbold">{Message.TFR.terminalSuccessModalQueryNote}</small>
                            </div>
                            <div class="TerminalSuccessLowerNoteDiv">
                                <small class="TerminalSuccessLowerNote">{Message.TFR.terminalSuccessModalNote}<small class="TerminalSuccessLowerNoteRed">tptcallcentre@transnet.net</small></small>
                            </div>
                        </div>
                    </div>
                </TerminalSuccessModal>
            </div >
        );
    }
}

export default CreateTPTRequest;